import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Col, Container, Form, Image, InputGroup, Row, Spinner } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Iobserver, LoginInfo } from '../App';
import { isLoggin, updateRenzoku, updateTile } from '../service/LoginService';
import ApiFetch from './ApiFetch';
import Category from './Category';
import Dialog from './Dialog';
import Header from './Header';
import ReactGA from "react-ga4"
import Footer from './Footer';
import { LinkContainer } from 'react-router-bootstrap';
import CampaignMessage from './CampaignMessage';
import { useTranslation } from "react-i18next";
import Thumb from './common/Thumb';
import Tile from './common/Tile';
import Masonry from 'react-masonry-css';
import { Button } from '@mui/material';

async function getFavoriteList(order,page){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/image/list/"+order+"/"+page).then((r)=>r.json().then((json)=>{
        return json
    }))
}
const Favorite = () => {
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    // ナビゲート
    const navigate = useNavigate();

    // 画像遅延ロード
    const observer = useContext(Iobserver)

    // URLパラメータ
    let param = useParams();

    const [imageList,setImageList] = useState([...Array(0)])
    const [message,setMessage] = useState('')

    // 検索情報
    const [page,setPage] = useState(0)
    const [order,setOrder] = useState(param.order || "favorite_datetime_desc")

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    useEffect(() => {
        if(loginInfo.result === false){
            navigate("/")
        }
    },[loginInfo])

    // ページ遷移
    useEffect(() =>{
        // タイトル設定
        document.querySelector("title").textContent = t("category.favorite") + " - " + t("common.siteName")

        let currentPage = 1
        if(param.page === undefined){
            currentPage = 1
        } else {
            currentPage = parseInt(param.page)
        }
        setPage(currentPage)
    },[loginInfo,page])

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(false)
    const [loading,setLoading] = useState(false)

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList])

    // ページ遷移
    useEffect(() =>{
        // 初期処理では取得せず、ページ番号が確定してから取得する
        if(page > 0){
            setLoading(true)
            getFavoriteList(order,page).then(json => {
                if(json.result){
                    if(json.data.length > 0){
                        setMessage("")
                    } else {
                        setMessage("いいねしている投稿はありません。")
                    }
                    // スクロールを最上位に戻す
                    window.scrollTo({top:0,left:0,behavior:"instant"})
                    setImageList(json.data)
                }
                setLoading(false)
            })
        }
    },[order,page])

    const breakpointColumnsObj = {
        default: 9,
        1800: 8,
        1600: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <Container className='mt-3 mb-3' style={{fontSize:"24px",fontWeight:"bold",borderLeft:"10px solid lightblue"}}>
            <Icon.HandThumbsUpFill style={{paddingBottom:"5px",color:"orange"}} />
            &nbsp;
            {t("category.favorite")}
            &nbsp;
            <LinkContainer to={"/history"}><Button variant='outlined'>{t("category.browsingHistory")}</Button></LinkContainer>
        </Container>
        <Container className='d-flex p-0'>
            <Row>
                <Col xs={7} sm={7} md={4} lg={3} xl={3} xxl={3} style={{}}>
                    <Form.Select style={{width:"200px"}} className="m-1 d-inline" value={order} onChange={(e) => {
                            setOrder(e.currentTarget.value)
                        }}>
                        <option value="favorite_datetime_desc">いいねした順</option>
                        <option value="favorite_desc">いいね多い順</option>
                        <option value="pv_desc">閲覧数多い順</option>
                        <option value="post_desc">投稿日新しい順</option>
                        <option value="post_asc">投稿日古い順</option>
                    </Form.Select>
                </Col>
                <Col xs={5} sm={5} md={8} lg={2} xl={2} xxl={2} style={{}}>
                    <Button variant='outlined' className='m-1' onClick={() => setPage(1)}>1ページ目へ</Button>
                </Col>
                <Col xs={6} sm={6} md={6} lg={3} xl={3} xxl={3} style={{}}>
                    <InputGroup className='m-1' style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={omitContinuous} onClick={(e) => {
                                updateRenzoku(e.currentTarget.checked ? "on" : "off").then(r => {
                                    if(r.result){
                                        isLoggin().then(json => {
                                            setLoginInfo(json)
                                        })
                                    }
                                })
                                //setOmitContinuous(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
                    </InputGroup>
                </Col>
                <Col xs={6} sm={6} md={6} lg={3} xl={3} xxl={3} style={{}}>
                    <InputGroup className='m-1' style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={tileMode} onClick={(e) => {
                            updateTile(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setTileMode(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.tileMode")} readOnly />
                    </InputGroup>
                </Col>
            </Row>
        </Container>
        <Container>
            {loading ? <Spinner animation="border" size="lg" style={{marginTop:"10px"}} /> : ""}
        </Container>
        <Container>{message}</Container>
        {tileMode ? (
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
                >
                {imageList.map((data,i) => {
                    if(i === 50){
                        return ""
                    }
                    if(data.mute === 1 || (omitContinuous && i > 0 && imageList[i-1].user_id === data.user_id)){
                        return <span data-no={i} className="lazy" key={i}></span>
                    }
                return <Tile data={data} i={i} dialog={dialog} key={i} list={imageList.filter(d => d.mute === 0)} listName={t("category.favorite")} />

                })}
            </Masonry>
        ) : (
        <div className='d-flex flex-row justify-content-start flex-wrap w-100'>
            {imageList.map((data,i) => {
                if(i === 50){
                    return ""
                }
                if(data.mute === 1 || (omitContinuous && i > 0 && imageList[i-1].user_id === data.user_id)){
                    return <span data-no={i} className="lazy" key={i}></span>
                }
            return <Thumb data={data} i={i} dialog={dialog} key={i} list={imageList.filter(d => d.mute === 0)} listName={t("category.favorite")} />
            })}
        </div>
        )}
        <Container className='d-flex justify-content-between' style={{width:"200px"}}>
            {page > 1 ? (
                    <Button variant='contained' onClick={() => {
                        let p = page - 1
                        setPage(p)
                        navigate("/favorite/" + p)
                    } }>{t("common.prev")}</Button>
                ) : <Button variant='contained' disabled>{t("common.prev")}</Button>}
            {imageList.length > 50 ? (
                    <Button variant='contained' onClick={() => {
                        let p = page + 1
                        setPage(p)
                        navigate("/favorite/" + p)
                    } }>{t("common.next")}</Button>
                ) : <Button variant='contained' disabled>{t("common.next")}</Button>}
        </Container>
        <Footer />
    </div>
    )
}

export default Favorite;
